import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=c65d6828&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=c65d6828&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65d6828",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c65d6828')) {
      api.createRecord('c65d6828', component.options)
    } else {
      api.reload('c65d6828', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=c65d6828&scoped=true&", function () {
      api.rerender('c65d6828', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ndmIV0VK7z4x/JS/comp/CookieBox.vue"
export default component.exports